import { Suspense, lazy, type ReactNode } from "react";

import type { MarkdownViewProps } from "./MarkdownView";

const MarkdownView = lazy(() => import("./MarkdownView"));

/** `MarkdownView` behind its own chunk boundary, with a plain loading line. */
export function LazyMarkdown(props: MarkdownViewProps): ReactNode {
  return (
    <Suspense
      fallback={
        <p role="status" className="text-sm text-muted">
          Loading…
        </p>
      }
    >
      <MarkdownView {...props} />
    </Suspense>
  );
}
